/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useMemo } from "react";
import { Table } from "antd";

const Datatable = ({
  props,
  columns,
  dataSource = [],
  summary,
  currentPage,
  pageSize,
  onPageChange,
  rowKey = "id",
  pagination = true,
   loading,        // this way spinner doesn't go into restProps
  ...restProps
}) => {
  const isControlledPagination =
    currentPage !== undefined &&
    pageSize !== undefined &&
    typeof onPageChange === "function";

  const paginationConfig = useMemo(() => {
    if (pagination === false) return false;

    const basePagination = {
      locale: { items_per_page: "" },
      nextIcon: (
        <span>
          <i className="fa fa-angle-right" />
        </span>
      ),
      prevIcon: (
        <span>
          <i className="fa fa-angle-left" />
        </span>
      ),
      showSizeChanger: true,
      pageSizeOptions: ["10", "20", "30"],
    };

    if (isControlledPagination) {
      return {
        ...basePagination,
        current: currentPage,
        pageSize: pageSize,
        total: dataSource.length,
        onChange: (page, size) => onPageChange(page, size),
      };
    }

    return {
      ...basePagination,
      defaultPageSize: 20,
    };
  }, [pagination, isControlledPagination, currentPage, pageSize, onPageChange, dataSource.length]);

  const resolvedRowKey =
    typeof rowKey === "function"
      ? rowKey
      : (record) => record?.[rowKey] ?? record?.id;

  return (
    <Table
      className="table datanew dataTable no-footer"
      columns={columns}
      dataSource={dataSource}
      rowKey={resolvedRowKey}
      pagination={paginationConfig}
      summary={summary}
      {...restProps}
    />
  );
};

export default Datatable;